<template>
	<div>
		<Layout :navFixed="true" :transparent="true">
			<HomeSlider />

			<div class="container">
				<div class="row justify-content-center">
					<div class="col ">
						<div class="d-flex mt-5 mb-3">
							<div class="block block-1 bg-white flex-grow-4 mr-3" :style="`background-image: url(${require('@/assets/img/section-background.png')})`">
								<div class="content flex-grow-1 ml-4" v-if="sectionWelcome">
									<div class="content-block">
										<h1 class="title">
											<strong>{{ sectionWelcome.title }}</strong>
										</h1>

										<div class="mt-3" v-html="sectionWelcome.intro"></div>

										<!-- <router-link
											v-if="item.hasBody && !item.link"
											tag="a"
											:to="`/${item.slug}`"
											class="btn btn-primary mt-3"
										>
											Ver adicionales
										</router-link>

										<router-link v-if="item.link" tag="a" :to="`${item.link}`" class="btn btn-primary mt-3">
											Ver adicionales
										</router-link> -->
									</div>
								</div>
								<div class=" only-desktop align-items-center justify-content-between order-first">
									<youtube video-id="XqJp575uga4" :player-vars="{ autoplay: 1, controls: 0, rel: 0, modestbranding: 1, Origin: 'https://www.surcampers.uy/' }"></youtube>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="container">
				<div class="row ">
					<div class="col">
						<FeaturedProducts />
					</div>
				</div>
			</div>

			<HomeAbout />

			<div class="container">
				<div class="row mt-5 mb-3">
					<div class="col-12 col-md-4" v-if="sectionQuality">
						<div class="content-block mt-3">
							<h1 class="title">
								<strong>{{ sectionQuality.title }}</strong>
							</h1>
							<div class="mt-3" v-html="sectionQuality.intro"></div>
						</div>
					</div>
					<div class="col-12 col-md-8">
						<VueSlickCarousel :arrows="false" :dots="false" :slidesToShow="1" :slidesToScroll="1" :autoplay="true">
							<div>
								<img :src="require('@/assets/img/quality-1.jpg')" class="img-fluid" />
							</div>
							<div>
								<img :src="require('@/assets/img/quality-2.jpg')" class="img-fluid" />
							</div>
							<div>
								<img :src="require('@/assets/img/quality-3.jpg')" class="img-fluid" />
							</div>
						</VueSlickCarousel>
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import Layout from '@/components/Layout'
import HomeSlider from '@/views/home/HomeSlider'
import HomeBrandsAvailable from '@/views/home/HomeBrandsAvailable'
import FeaturedProducts from '@/views/home/FeaturedProducts'
import HomeSections from '@/views/home/HomeSections'
import HomeContact from '@/views/home/HomeContact'
import HomeAbout from '@/views/home/HomeAbout'

export default {
	name: 'Home',
	components: {
		Layout,
		HomeSlider,
		HomeBrandsAvailable,
		FeaturedProducts,
		HomeSections,
		HomeContact,
		HomeAbout,
	},
	data() {
		return {
			sectionWelcome: null,
			sectionQuality: null,
		}
	},

	async beforeMount() {
		this.sectionWelcome = await this.loadPage('welcome')
		this.sectionQuality = await this.loadPage('elegimos-calidad')
	},
	methods: {
		loadPage(page) {
			return this.$apollo
				.query({
					query: gql`
						query($slug: String!) {
							page(slug: $slug) {
								title
								intro
								body
							}
						}
					`,
					variables: {
						slug: page,
					},
				})
				.then(({ data }) => {
					return data.page
				})
		},
	},
}
</script>

<style scoped>
.separator {
	display: flex;
	width: 100%;
	justify-content: center;
}
.separator:after {
	content: '';
	display: block;
	width: 70px;
	height: 30px;
	border-bottom: 4px solid #f3f3f3;
	border-left: 4px solid #f3f3f3;
	margin: 2px;
}
.separator:before {
	content: '';
	display: block;
	width: 70px;
	height: 30px;
	border-bottom: 4px solid #f3f3f3;
	border-right: 4px solid #f3f3f3;
	margin: 2px;
}
</style>
